var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagonXmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 1.58398C4.28125 0.927734 5 0.490234 5.78125 0.490234H11.1875C11.9688 0.490234 12.6875 0.927734 13.0938 1.58398L16 6.33398C16.4375 7.05273 16.4375 7.95898 16 8.67773L13.0938 13.4277C12.6875 14.084 11.9688 14.4902 11.1875 14.4902H5.78125C5 14.4902 4.28125 14.084 3.875 13.4277L0.96875 8.67773C0.53125 7.95898 0.53125 7.05273 0.96875 6.33398L3.875 1.58398ZM5.96875 6.02148L7.4375 7.49023L5.96875 8.95898C5.65625 9.27148 5.65625 9.74023 5.96875 10.0215C6.25 10.334 6.71875 10.334 7 10.0215L8.46875 8.55273L9.96875 10.0215C10.25 10.334 10.7188 10.334 11 10.0215C11.3125 9.74023 11.3125 9.27148 11 8.95898L9.53125 7.49023L11 6.02148C11.3125 5.74023 11.3125 5.27148 11 4.95898C10.7188 4.67773 10.25 4.67773 9.96875 4.95898L8.46875 6.45898L7 4.95898C6.71875 4.67773 6.25 4.67773 5.96875 4.95898C5.65625 5.27148 5.65625 5.74023 5.96875 6.02148Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonXmark);
export default __webpack_public_path__ + "static/media/hexagon-xmark.67e18482.svg";
export { ForwardRef as ReactComponent };